import { authExchange } from "@urql/exchange-auth"
import { cacheExchange, createClient, fetchExchange } from "urql"
import { auth } from "./firebase"

// route rewriting is defined and handled by firebase hosting
// see: firebase.json
const URL = "/api/graphql"

export const createUrqlClient = () =>
  createClient({
    url: URL,
    exchanges: [
      cacheExchange,
      authExchange(async (utils) => {
        let token = await auth.currentUser()?.getIdToken()
        return {
          addAuthToOperation(operation) {
            return token
              ? utils.appendHeaders(operation, {
                  Authorization: `Bearer ${token}`,
                })
              : operation
          },
          didAuthError: (error) =>
            error.graphQLErrors.some((e) => e.extensions?.code === "UNAUTHENTICATED"),
          async refreshAuth() {
            token = await auth.currentUser()?.getIdToken()
          },
        }
      }),
      fetchExchange,
    ],
  })
